import React from "react";

const PricingSection = ({ setShowModal }) => {
  return (
    <section id="pricing" className="py-24">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Why pay more for
            <br />
            <span className="text-[hsl(30,100%,85%)]">less features?</span>
          </h2>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
            While others charge you for basic e-commerce plus expensive add-ons, we include everything: email marketing, SMS campaigns, review management, loyalty programs, affiliate tracking, wholesale portals, and subscriptions - all unified in one platform.
          </p>
        </div>
        
        <div className="grid md:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {/* Platform + Apps */}
          <div className="bg-gray-800/30 p-6 rounded-2xl border border-gray-700 flex flex-col">
            <h3 className="text-xl font-bold mb-4 text-red-400">Platform + Apps</h3>
            <div className="text-3xl font-bold mb-4">$150+<span className="text-lg text-gray-400">/month</span></div>
            <p className="text-sm text-gray-400 mb-6">Basic plan + required apps for email, SMS, reviews, loyalty, etc.</p>
            <ul className="space-y-2 mb-8 flex-grow">
              <li className="flex items-center text-gray-300 text-sm">
                <span className="text-red-400 mr-3">✗</span>
                Email marketing (over $50/month)
              </li>
              <li className="flex items-center text-gray-300 text-sm">
                <span className="text-red-400 mr-3">✗</span>
                Reviews (over $15/month)
              </li>
              <li className="flex items-center text-gray-300 text-sm">
                <span className="text-red-400 mr-3">✗</span>
                Store locator (over $10/month) 
              </li>
              <li className="flex items-center text-gray-300 text-sm">
                <span className="text-red-400 mr-3">✗</span>
                Loyalty (over $30/month)
              </li>
              <li className="flex items-center text-gray-300 text-sm">
                <span className="text-red-400 mr-3">✗</span>
                Affiliate Programs (over $30/month)
              </li>
              <li className="flex items-center text-gray-300 text-sm">
                <span className="text-red-400 mr-3">✗</span>
                Subscriptions (over $20/month + transaction fees)
              </li>
            </ul>
          </div>
          
          {/* Basic Plan */}
          <div className="bg-gray-800/30 p-6 rounded-2xl border border-gray-700 flex flex-col">
            <h3 className="text-xl font-bold mb-4 text-white">Basic Plan</h3>
            <div className="text-3xl font-bold mb-4">$70<span className="text-lg text-gray-400">/month</span></div>
            <p className="text-sm text-gray-300 mb-6">Everything you need to get started</p>
            <ul className="space-y-2 mb-8 flex-grow">
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                Zero transaction fees
              </li>
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                Review engine
              </li>
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                Store Locator
              </li>
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                Bundles (including build-your-own bundles)
              </li> 
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                Subscriptions & unified analytics
              </li>
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                Basic email marketing
              </li>
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent font-semibold">AND dedicated Slack support </span>
              </li>
            </ul>
            <button 
              onClick={() => setShowModal(true)}
              className="w-full bg-[hsl(30,100%,85%)] text-black py-3 rounded-full font-medium hover:bg-white transition-colors text-sm"
            >
              Book a Demo
            </button>
          </div>
          
          {/* Premium Plan */}
          <div className="bg-gradient-to-br from-[hsl(30,100%,85%)]/10 to-white/5 p-6 rounded-2xl border border-[hsl(30,100%,85%)]/30 relative flex flex-col">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <span className="bg-[hsl(30,100%,85%)] text-black px-4 py-2 rounded-full text-sm font-medium">
                Most Popular
              </span>
            </div>
            <h3 className="text-xl font-bold mb-4 text-[hsl(30,100%,85%)]">Premium Plan</h3>
            <div className="text-3xl font-bold mb-4">$125<span className="text-lg text-gray-400">/month</span></div>
            <p className="text-sm text-gray-300 mb-6">Everything in Basic + advanced features</p>
            <ul className="space-y-2 mb-8 flex-grow">
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                Everything in Basic Plan
              </li>
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                Wholesale portals
              </li>
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                Advanced email marketing
              </li>
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                Affiliate programs
              </li>
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                Loyalty programs
              </li>
            </ul>
            <button 
              onClick={() => setShowModal(true)}
              className="w-full bg-[hsl(30,100%,85%)] text-black py-3 rounded-full font-medium hover:bg-white transition-colors text-sm"
            >
              Book a Demo
            </button>
          </div>

          {/* Enterprise Plan */}
          <div className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 p-6 rounded-2xl border border-purple-500/30 relative flex flex-col">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <span className="bg-gradient-to-r from-purple-500 to-blue-500 text-white px-4 py-2 rounded-full text-sm font-medium">
                Enterprise
              </span>
            </div>
            <h3 className="text-xl font-bold mb-4 text-purple-400">Enterprise Plan</h3>
            <div className="text-3xl font-bold mb-4">Custom<span className="text-lg text-gray-400"> pricing</span></div>
            <p className="text-sm text-gray-300 mb-6">For large-scale businesses with custom needs</p>
            <ul className="space-y-2 mb-8 flex-grow">
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                Everything in Premium Plan
              </li>
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                Custom quizzes & interactive features
              </li>
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                Advanced loyalty & subscription features
              </li>
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                High-volume email sends
              </li>
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                SMS marketing campaigns
              </li>
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                AI-powered landing pages
              </li>
              <li className="flex items-center text-white text-sm">
                <span className="text-green-400 mr-3">✓</span>
                AI-powered templates & photography
              </li>
            </ul>
            <button 
              onClick={() => setShowModal(true)}
              className="w-full bg-gradient-to-r from-purple-500 to-blue-500 text-white py-3 rounded-full font-medium hover:from-purple-600 hover:to-blue-600 transition-all text-sm"
            >
              Book a Demo
            </button>
          </div>
        </div>
        
        <div className="text-center mt-12">
          <p className="text-xl text-gray-300">
            Save <span className="text-[hsl(30,100%,85%)] font-bold">$500+</span> per year with Basic • Save <span className="text-[hsl(30,100%,85%)] font-bold">$1000+</span> per year with Premium
          </p>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;